import { useRef } from "react";
import { fileReadUtil } from "../../utility/ImportFile";
import { acceptedFileFormats, supportedFileTypes } from "../../EximConstants";
import {
  DKLabel,
  DKButton,
  showToast,
  TOAST_TYPE,
  showLoader,
  showAlert,
  removeLoader,
  DKIcons,
} from "deskera-ui-library";
import UploadCloud from "../../../../assets/images/upload_cloud_outlined.svg";
import UploadCloudFilled from "../../../../assets/images/upload_cloud_filled.svg";
import { onDownload } from "../../utility/ExportData";
import { CONSTANTS } from "../../../../constants/Constant";
import i18next from "i18next";

const FileImporter = (props) => {
  const uploadInput = useRef();
  const cloudImageRef = useRef();

  const isFileAcceptable = (selectedFile) => {
    if (!selectedFile) return false;
    return acceptedFileFormats.some((acceptedFormat) =>
      selectedFile.name.includes(acceptedFormat)
    );
  };

  const handleFiles = (selectedFiles) => {
    if (!selectedFiles.length) {
      showToast("File not found", TOAST_TYPE.FAILURE);
    }

    const selectedFile = selectedFiles[0];
    if (isFileAcceptable(selectedFile)) {
      showLoader("Processing the uploaded file...");

      /* Parsing the file at Client End */
      fileReadUtil(selectedFile, supportedFileTypes.CSV)
        .then((res) => {
          props.setData({
            fileInfo: {
              name: selectedFile.name,
              size: selectedFile.size,
              mimeType: selectedFile.type,
            },
            fileContent: res,
            /* Reset mapped values whenever new file is uploaded */
            mappedHeaders: null,
            importRecords: null,
            invalidRows: null,
          });
        })
        .catch((err) => {
          showToast(err.message, TOAST_TYPE.FAILURE);
          uploadInput.current.value = "";
          if(err?.status === 500 && err?.message?.includes("CONTENT_TYPE_NOT_ALLOWED")) {
            showAlert(i18next.t('FAIL_TO_UPLOAD'), i18next.t('FILE_FORMAT_TYPE_ERROR_MSG'));
          }
        });

      /* Uploading the file for Import Logs */
      props
        .generateAuditLog(selectedFile)
        .then((auditLogId) => {
          removeLoader();
          showToast(
            "File uploaded successfully, please continue to next step for mapping your columns.",
            TOAST_TYPE.SUCCESS
          );
          props.setData({ auditLogId });
        })
        .catch((error) => {
          removeLoader();
          showToast(
            "Something went wrong while uploading file to server",
            TOAST_TYPE.FAILURE
          );
          uploadInput.current.value = "";
          if(error?.status === 500 && error?.message?.includes("CONTENT_TYPE_NOT_ALLOWED")) {
            showAlert(i18next.t('FAIL_TO_UPLOAD'), i18next.t('FILE_FORMAT_TYPE_ERROR_MSG'));
          }
        });
    } else {
      showToast("Only CSV/XLSX file types are allowed", TOAST_TYPE.FAILURE);
    }
  };

  const onUploadInputClicked = (event) => {
    const selectedFiles = event.target.files;
    handleFiles(selectedFiles);
  };

  const onFileDrop = (event) => {
    event.stopPropagation();
    event.preventDefault();
    cloudImageRef.current.src = UploadCloud;
    const files = event.dataTransfer.files;
    handleFiles(files);
  };

  const onDragenter = (e) => {
    e.stopPropagation();
    e.preventDefault();
    cloudImageRef.current.src = UploadCloudFilled;
  };

  const onDragOver = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };

  function getImportPortal() {
    return (
      /* upload area */
      <div
        className="column parent-width bg-gray1 border-m border-radius-s align-items-center p-v-r p-h-l m-v-xl cursor-hand"
        onDragEnter={onDragenter}
        onDragOver={onDragOver}
        onDrop={onFileDrop}
        onClick={() => {
          uploadInput.current.click();
        }}
      >
        <img
          style={{ height: "100px", width: "200px" }}
          className="m-r"
          src={UploadCloud}
          ref={cloudImageRef}
          alt="Upload Cloud"
        />

        <div className="row parent-width justify-content-center position-relative p-h-xxl">
          <DKLabel text="Drop .xlsx or .csv" />
          <DKButton
            className="fw-m border-none bg-white border-m ml-r"
            title="Choose a file"
            icon={DKIcons.ic_document}
            onClick={() => {
            //   uploadInput.current.click();
            }}
          />
          <input
            className="parent-width parent-height position-absolute"
            style={{ visibility: "hidden" }}
            type="file"
            accept=".csv,.xlsx,text/csv"
            onChange={onUploadInputClicked}
            ref={uploadInput}
          />
        </div>

        {<DKButton 
          icon={DKIcons.ic_download} 
          className=" border-m mt-xl fw-m mb-l"
          title="Download Sample File" 
          onClick={(e) => { 
            e.stopPropagation();
            onDownload(CONSTANTS.CANDIDATE);}}
        /> }      </div>
    );
  }

  function getFileInfoPanel() {
    return props.fileInfo ? (
      <div className="column parent-width mb-r">
        <DKLabel text="File details" className="fw-m" />
        <div className="row justify-content-between bg-gray1 border-m p-m border-radius-s mt-r">
          <DKLabel text={props.fileInfo.name} className="" />
          <DKLabel
            className="text-blue"
            text={`${Number(props.fileInfo.size) / 1000} Kb`}
          />
        </div>
      </div>
    ) : null;
  }

  return (
    <div
      className="column align-items-center bg-white border-radius-s shadow-s p-xxl"
      style={{ width: "550px", paddingLeft: 60, paddingRight: 60 }}
    >
      <DKLabel text="File Uploader" className="fw-m fs-m" />
      <DKLabel
        text="Upload a file you want to import"
        className="text-gray mt-s text-align-center"
      />
      {getImportPortal()}
      {getFileInfoPanel()}
    </div>
  );
};

export default FileImporter;
